import React, { FC, ReactNode } from 'react';
import { QueryResult } from 'react-apollo';

import { UserProfile, GetUserSearchesV2Component, GetUserSearchesV2QueryVariables } from 'api';
import { QueryManager } from 'components';
import { LoaderTypes } from 'types/app';

interface IProps {
  variables: GetUserSearchesV2QueryVariables;
  children: (data: UserProfile[], count: number, onLoadMore?: () => void) => ReactNode;
  loader?: LoaderTypes;
}

const GetUserSearchesV2: FC<IProps> = ({ children, variables, loader, ...queryProps }) => {
  function handleLoadMore(queryResult: QueryResult, nextId: string) {
    const { data, fetchMore } = queryResult;
    const currentResult = data.getUserSearchesV2;

    return fetchMore({
      variables: {
        next_id: currentResult.next_id,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return prev;
        }

        const prevResult = prev.getUserSearchesV2;
        const nextResult = fetchMoreResult.getUserSearchesV2;
        const updatedResult = {
          ...prevResult,
          ...nextResult,
          results: [...prevResult.results, ...nextResult.results],
        };

        return { ...prev, getUserSearchesV2: updatedResult };
      },
    });
  }

  return (
    <GetUserSearchesV2Component fetchPolicy="network-only" variables={variables} {...queryProps}>
      {(queryResult: QueryResult) => (
        <QueryManager {...queryResult} loader={loader} {...queryProps}>
          {({ data }) => {
            if (!data?.getUserSearchesV2) {
              return children([], 0, null);
            }
            const { results, total_count, next_id } = data.getUserSearchesV2;
            const onLoadMore =
              results.length < total_count ? () => handleLoadMore(queryResult, next_id) : undefined;
            return children(results, total_count, onLoadMore);
          }}
        </QueryManager>
      )}
    </GetUserSearchesV2Component>
  );
};

export default GetUserSearchesV2;
